import React, { useEffect, useState } from 'react';
import { tl } from '../utils/inlineI18n';
import './battle/BotMeter.css';

export const BOT_BLOCKED_EVENT = 'text2-bot-blocked';

/** Sunucu bot şüphesiyle oyuna girişi engellediğinde (HTTP 423 / savaş soketi) çağrılır. */
export const notifyBotBlocked = (untilUnixSec) => {
  const until = Number(untilUnixSec) || Math.floor(Date.now() / 1000) + 300;
  window.dispatchEvent(new CustomEvent(BOT_BLOCKED_EVENT, { detail: { until } }));
};

// Tüm ekranı kaplayan geri sayım; süre bitince sayfa yenilenir.
const BotBlockedOverlay = () => {
  const [until, setUntil] = useState(0);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const onBlocked = (e) => setUntil((prev) => Math.max(prev, (e.detail?.until || 0) * 1000));
    window.addEventListener(BOT_BLOCKED_EVENT, onBlocked);
    return () => window.removeEventListener(BOT_BLOCKED_EVENT, onBlocked);
  }, []);

  useEffect(() => {
    if (!until) return undefined;
    const id = setInterval(() => {
      const t = Date.now();
      setNow(t);
      if (t >= until) {
        clearInterval(id);
        window.location.reload();
      }
    }, 1000);
    return () => clearInterval(id);
  }, [until]);

  if (!until || now >= until) return null;
  const left = Math.max(0, Math.ceil((until - now) / 1000));
  const mm = String(Math.floor(left / 60)).padStart(2, '0');
  const ss = String(left % 60).padStart(2, '0');
  return (
    <div className="bot-verify-layer bot-blocked-layer" role="alertdialog" aria-modal="true">
      <div className="bot-blocked-box">
        <div className="bot-blocked-icon">⛔</div>
        <h3>{tl('Oyuna giriş geçici olarak engellendi', 'Game access temporarily blocked')}</h3>
        <p>
          {tl(
            'Bot doğrulaması kısa sürede ikinci kez gerekti. Bir süre sonra tekrar oynayabilirsin.',
            'The bot check was triggered twice in a short time. You can play again shortly.'
          )}
        </p>
        <div className="bot-blocked-timer">{mm}:{ss}</div>
      </div>
    </div>
  );
};

export default BotBlockedOverlay;
